import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_LabelLabel from "../templates/K_LabelLabel";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface LabelLabelOptions extends ComponentOptions {
    containerBind?: string | { type: string, value: string };
    bindLabel?: string;
    suffix?: string;
    suffixClasses?: string;
    valueClasses?: string;
    style?: string;
    labelbsc?: string;
    bsc?: string;
    labelBsc?: string;
    infoTooltip?: string;
    infoTooltipContent?: any;
}

export class LabelLabel extends TemplateComponent {

    options: LabelLabelOptions;

    constructor(options: LabelLabelOptions) {
        super(K_LabelLabel, options);
    }

    preRender() {
        const options = this.options;

        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bindLabel = buildDataBindSyntax(options.bindLabel, "label");
        options.bindValue = buildDataBindSyntax(options.bindValue, "label");
        options.suffix = buildDataBindSyntax(options.suffix, "label");
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }
    }

}
